<template>

    <Head>
        <title>Santiago - Vida y Órden</title>
    </Head>
    <Banners :banners="banners" />
    <div class="contenido-wrapper">
        <Tramites />
        <Santi />
        <Noticias :noticias="noticias" />
        <Eventos :eventos="eventos" />
        <Bolsa :empleos="empleos" />
        <Video :video="video" />
        <Reporta />
    </div>
</template>

<script>
import Banners from "../Shared/Home/Banners.vue"
import Tramites from "../Shared/Home/Tramites.vue"
import Santi from "../Shared/Home/Santi.vue"
import Noticias from "../Shared/Home/Noticias.vue"
import Eventos from "../Shared/Home/Eventos.vue"
import Video from "../Shared/Home/Video.vue"
import Reporta from "../Shared/Home/Reporta.vue"
import Bolsa from "../Shared/Home/Bolsa.vue"

export default {
    components: { Banners, Tramites, Santi, Noticias, Eventos, Video, Reporta, Bolsa },
    props: {
        noticias: Object,
        eventos: Object,
        eventos: Object,
        banners: Object,
        video: Object,
    }
}
</script>

<style>
h2 {
    margin-top: 0;
}
</style>
